/// <reference path="./d.ts-reference/index.d.ts" />
import 'babel-polyfill';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import '@seeneco-ui/api/global/atr-core-constants';
import '@seeneco-ui/api/global/atr-core-lib';
import { Auth } from '@seeneco-ui/business';

import { setMomentLocales } from '@utils';
import {
	api,
} from '@api';
import { App } from './app';
import { BASE_URL } from '@core/routing/urls';

setMomentLocales();

api.auth.checkAuth().then(([isAuthorized, ticketUID]) => {
	const authValue = {
		isAuthorized,
		ticketUID,
		loginPath: `${BASE_URL}/login`,
	};

	return ReactDOM.render(
		<Auth.Provider value={authValue}>
			<Router>
				<App />
			</Router>
		</Auth.Provider>,
		document.getElementById('app'));
});
